export default __webpack_public_path__ + "static/media/10_SangSong.32498ec7.png";